import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';

@Injectable({
  providedIn: 'root'
})
export class TripService {

  constructor(
    private http: HttpClient
  ) { }

  
  getAllTrips(queryParam:any) {
    const params = new HttpParams({fromObject: queryParam});
    return this.http.get(urls.API_URL + urls.ASSIGN_TRIPS, {params})
      .pipe(catchError(errorHandl));
  }

  getOperationTrips(queryParam:any) {
    const params = new HttpParams({fromObject: queryParam});
    return this.http.get(urls.API_URL + urls.OPERATION_TRIPS, {params})
      .pipe(catchError(errorHandl));
  }

  getTripById(id: any) {
    return this.http.get(urls.API_URL + urls.ASSIGN_TRIPS + `/${id}`)
      .pipe(catchError(errorHandl));
  }

  getTripEvents(queryParam: any) {
    const params = new HttpParams({ fromObject: queryParam });
    return this.http.get(urls.API_URL + urls.ASSIGN_EVENTS, { params })
      .pipe(catchError(errorHandl));
  }

  deleteBillingEvents(eventId: any) {
    return this.http.delete(urls.API_URL + urls.ASSIGN_EVENTS + `/${eventId}`)
      .pipe(catchError(errorHandl));
  }

  getPickerTripEvents(queryParam?: any) {
    const params = new HttpParams({ fromObject: queryParam });
    return this.http.get(urls.API_URL + urls.ASSIGN_EVENTS + urls.PICKER, { params })
      .pipe(catchError(errorHandl));
  }

  createTrip(payload:any,tripId?:any){
    if(tripId){
      return this.http.patch(urls.API_URL + urls.ASSIGN_TRIPS +'/'+tripId,payload)
      .pipe(catchError(errorHandl));
    }else{
      return this.http.post(urls.API_URL + urls.ASSIGN_TRIPS ,payload)
      .pipe(catchError(errorHandl));
    }

  }
  updateTrip(payload: any, tripId: any) {
      return this.http.patch(urls.API_URL + urls.ASSIGN_TRIPS + '/' + tripId + '/flags', payload)
        .pipe(catchError(errorHandl));

  }
  updateNotes(tripId: any, source: any, payload: any): any {
  if (source === 'trips') {
    return this.http.post(urls.API_URL + urls.ASSIGN_TRIPS + '/' + tripId + '/notes', payload)
      .pipe(catchError(errorHandl));
  }
  if (source === 'billing') {
    return this.http.patch(
      urls.API_URL + urls.ADJUST_TRIPS + `/${tripId}`, payload).pipe(catchError(errorHandl));
  }
  if (source === 'fundingsourceBilling') {
    return this.http.patch(
      urls.API_URL + urls.ADJUST_BILLING_TRIPS + `/${tripId}`, payload).pipe(catchError(errorHandl));
  }
}

  cloneTrip(tripId:any) {
    return this.http.get(urls.API_URL + urls.ASSIGN_TRIPS + '/' + tripId + '/clone')
      .pipe(catchError(errorHandl));

  }

  createStandingOrderTrip(payload: any, tripId: any) {
    if (tripId) {
      return this.http.patch(urls.API_URL + urls.STANDING_ORDER + '/' + tripId, payload)
        .pipe(catchError(errorHandl));
    } else {
      return this.http.post(urls.API_URL + urls.STANDING_ORDER, payload)
        .pipe(catchError(errorHandl));
    }

  }

  getAllStandingorder(queryParam:any) {
    const params = new HttpParams({ fromObject: queryParam });
    return this.http.get(urls.API_URL + urls.STANDING_ORDER, {params})
      .pipe(catchError(errorHandl));
  }


  getStandingorderById(id: any) {
  return this.http.get(urls.API_URL + urls.STANDING_ORDER + `/${id}`)
      .pipe(catchError(errorHandl));
  }

  parseFile(selectedFile:any , selFundSrc:any){
    const formData = new FormData();
    formData.append('file', selectedFile);
    formData.append('fundingsource', selFundSrc);
    return this.http.post(urls.API_URL + urls.PARSE_TRIPS, formData)
    .pipe(catchError(errorHandl));
  }

  assignToCompany(payload:any){
    return this.http.post(urls.API_URL + urls.ASSIGN_COMPANY ,payload)
    .pipe(catchError(errorHandl));
  }

  tripStatusForceUpdate(payload:any){
    return this.http.post(urls.API_URL + urls.TRIP_STATUS_FORCE_UPDATE ,payload)
    .pipe(catchError(errorHandl));
  }

  sendtoMarketPlace(payload: any) {
    return this.http.post(urls.API_URL + urls.ASSIGN_COMPANY, payload)
      .pipe(catchError(errorHandl));
  }

  calculateMiles(queryParam:any){
    const params = new HttpParams({ fromObject: queryParam });
    return this.http.get('https://routing.nemtplatform.com/ors/v2/directions/driving-car', {params})
    .pipe(catchError(errorHandl));
  }
   calculateFare(payload:any){
    return this.http.put(urls.API_URL + urls.ASSIGN_TRIPS + '/' + urls.FARE_ESTIMATION,payload)
      .pipe(catchError(errorHandl))
  }

    autoDistribute(payload:any){
      return this.http.post(urls.API_URL + urls.ASSIGN_TRIPS  + '/'+ urls.AUTO_DISTRIBUTE ,payload)
      .pipe(catchError(errorHandl));

  }

  getTripsLogs(id:any){
    return this.http.get(urls.API_URL + urls.ASSIGN_TRIPS + '/' + id + '/history',)
      .pipe(catchError(errorHandl));
  }
  getBillingTripsLogs(id:any){
    return this.http.get(urls.API_URL + urls.ADJUST_TRIPS + '/' + id + '/history',)
      .pipe(catchError(errorHandl));
  }
  getFundingSourceBillingTripsLogs(id:any){
    return this.http.get(urls.API_URL + urls.ADJUST_BILLING_TRIPS + '/' + id + '/history',)
      .pipe(catchError(errorHandl));
  }
  bulkVendorAdjust(payload: any){
    return this.http.post(urls.API_URL + urls.ADJUST_TRIPS + '/bulk-adjustment', payload)
      .pipe(catchError(errorHandl));
  }
  bulkFundingSourceAdjust(payload:any){
    return this.http.post(urls.API_URL + urls.ADJUST_BILLING_TRIPS + '/bulk-adjustment', payload)
      .pipe(catchError(errorHandl));
  }



  searchTrips(queryParam:any){
     const params = new HttpParams({ fromObject: queryParam });
    return this.http.get(urls.API_URL + urls.ASSIGN_TRIPS +'/'+ 'search',{params})
      .pipe(catchError(errorHandl));
  }

  updatePendingTripStatus(payload:any) {
    return this.http.post(urls.API_URL + urls.ASSIGN_TRIPS + '/' + urls.UPDATE_PENDING_TRIP_STATUS, payload)
      .pipe(catchError(errorHandl));
  }


  signatureUpdate(payload:any,tripId:any){
    return this.http.post(urls.API_URL + urls.ASSIGN_TRIPS +'/'+tripId +'/'+ urls.SIGNATURE_UPDATE ,payload)
      .pipe(catchError(errorHandl))
  }

  getTripsReport(params: any) {
    return this.http.get(urls.API_URL + urls.ASSIGN_TRIPS + '/report', { params })
      .pipe(catchError(errorHandl));
  }
}
